import { cn } from "@/utils/cn";

type NavUnreadDotProps = {
  /** Screen-reader text and tooltip, e.g. "2 chamados novos". */
  title: string;
  className?: string;
};

/** Notice dot drawn over a menu icon (unread chats, new tickets, ...). */
export const NavUnreadDot = ({ title, className }: NavUnreadDotProps) => (
  <span
    title={title}
    className={cn(
      "bg-hermes-primary ring-hermes-bg absolute -top-1 -right-1 size-2 rounded-full ring-2",
      className
    )}
  >
    <span className="sr-only">{title}</span>
  </span>
);
